var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      staticClass:
        "form-control material-input py-0 form my-1 moregage-data select-field",
      class: _vm.selectClassName,
      on: { change: _vm.handleInput },
    },
    [
      _c(
        "option",
        {
          staticClass: "text-grey",
          attrs: { value: "" },
          domProps: { selected: _vm.defaultSelect },
        },
        [_vm._v("\n    " + _vm._s(_vm.placeholder) + "\n  ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.options, function (option) {
        return _c(
          "option",
          {
            key: option.value,
            class: option.disabled ? "text-grey" : "",
            attrs: { disabled: option.disabled },
            domProps: {
              selected: _vm.setSelectedOption(option),
              value: option.value,
            },
          },
          [_vm._v("\n    " + _vm._s(option.label) + "\n  ")]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }